import React, { forwardRef } from 'react';
import Box from '../Box';
import type { BoxProps } from '../Box/Box';

export type SelectOption = {
  id?: string | number | null;
  value?: string | number;
  label?: string | number;
  name?: string;
  disabled?: boolean;
  description?: string;
};

interface SelectProps extends BoxProps {
  options: SelectOption[];
  placeholder?: string;
  enablePlaceholder?: boolean;
  allowNull?: boolean;
  disabled?: boolean;
}

const Select = forwardRef(
  (
    {
      options = [],
      placeholder,
      enablePlaceholder = false,
      allowNull,
      disabled,
      ...restProps
    }: React.PropsWithRef<
      React.SelectHTMLAttributes<HTMLSelectElement> & SelectProps
    >,
    ref?: React.Ref<HTMLSelectElement>,
  ) => {
    return (
      <Box
        disabled={disabled ?? false}
        as="select"
        ref={ref}
        width="100%"
        height="32px"
        color="input.text"
        opacity={1}
        fontSize={2}
        borderWidth={1}
        borderColor="input.border"
        borderStyle="solid"
        bg={
          !enablePlaceholder ? 'input.disabledBackground' : 'input.background'
        }
        {...restProps}
      >
        {placeholder !== undefined ? (
          <option disabled={!enablePlaceholder} value="">
            {placeholder}
          </option>
        ) : null}
        {options.map(
          ({
            id,
            value = id,
            label = value,
            name = label ?? 'empty',
            disabled,
            description,
          }) => (
            <option
              key={id || value}
              value={value != null ? value : allowNull ? '' : name}
              disabled={disabled}
            >
              {name}
              {description ? ` ${description}` : null}
            </option>
          ),
        )}
      </Box>
    );
  },
);

export default Select;
